import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import NewsArticleStore from '@src/pages/news-article/store';
import NaviBar from '@src/business-components/navibar';

const styles = require('./index.less');

const NewsArticle = ({ store }) => {
  store.use();
  return (
    <Page className={styles.root}>
      <div className={styles.naviBarBox}>
        <NaviBar store={store.navibarStore} />
      </div>
      <div className={styles.rootContent}>
        <div className={styles.header}>
          {/* <div className={styles.kv_bg} /> */}
          <div className={styles.header_content}>
            {JSON.parse(sessionStorage.getItem('from')) && (
              <div className={styles.typeBox}>
                <div className={styles.type1} onClick={() => store.goto(JSON.parse(sessionStorage.getItem('from'))[0])}>
                  {JSON.parse(sessionStorage.getItem('from'))[0]}
                </div>
                <div className={styles.line}>/</div>
                <div className={styles.type2} onClick={() => store.goto(JSON.parse(sessionStorage.getItem('from'))[1])}>
                  {/* {JSON.parse(sessionStorage.getItem('from'))[1]} */}
                  招募列表
                </div>
                <div className={styles.line}>/</div>
                <div className={styles.type3}>详情</div>
              </div>
            )}

            <div className={styles.title}>{store.title}</div>
            <div className={styles.time}>{store.createDate}</div>
          </div>
        </div>
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: store.content }} />
      </div>
    </Page>
  );
};

export default wrapStore(NewsArticle, NewsArticleStore);
